// Export van overleg-notulen naar PDF (jsPDF + autotable) en Word (gedeelde HTML via downloadWord).
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { downloadWord } from "@/lib/weekReport";

const esc = (s) => String(s == null ? "" : s).replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
const dnl = (s) => esc(s).replace(/\n/g, "<br>");

export function buildOverlegHTML(o) {
  const titel = o.titel || o.type || "Overleg";
  const acties = Array.isArray(o.acties) ? o.acties.filter((a) => a && (a.wat || a.wie || a.wanneer)) : [];
  const infoRow = (l, v) => (v ? `<tr><th>${esc(l)}</th><td>${dnl(v)}</td></tr>` : "");
  const actieRows = acties.length
    ? acties.map((a) => `<tr><td>${esc(a.wat)}</td><td>${esc(a.wie)}</td><td>${esc(a.wanneer)}</td></tr>`).join("")
    : `<tr><td colspan="3" class="sub">Geen actiepunten vastgelegd.</td></tr>`;
  return `<!doctype html><html lang="nl"><head><meta charset="utf-8"><title>${esc(titel)}</title>
<style>
@page{size:A4;margin:16mm}
*{box-sizing:border-box}
body{font-family:'Helvetica Neue',Arial,sans-serif;color:#0f172a;font-size:12px;margin:0}
.head{border-bottom:3px solid #1C64B0;padding-bottom:10px;margin-bottom:14px}
.brand{font-weight:800;font-size:15px}
.brandsub{color:#64748b;font-size:11px}
h1{color:#1C64B0;font-size:20px;margin:6px 0 2px}
.meta{color:#64748b;font-size:11px;margin-bottom:12px}
h2{color:#1C64B0;font-size:13px;margin:18px 0 6px;border-bottom:2px solid #e2e8f0;padding-bottom:4px}
table{border-collapse:collapse;width:100%;margin-bottom:8px}
th,td{padding:6px 9px;border-bottom:1px solid #e2e8f0;text-align:left;vertical-align:top}
.info th{width:120px;background:#f8fafc;color:#475569;font-size:11px}
.acties th{background:#f1f5f9;font-size:10px;text-transform:uppercase;letter-spacing:.04em;color:#475569}
.txt{white-space:pre-wrap;line-height:1.5}
.sub{color:#94a3b8}
.sig{margin-top:40px}
.sigline{border-top:1px solid #94a3b8;width:240px;margin:26px 0 4px;height:1px}
.foot{margin-top:18px;border-top:1px solid #e2e8f0;padding-top:8px;color:#94a3b8;font-size:9px}
</style></head><body>
<div class="head"><div class="brand">Clazing Convenience Food B.V.</div><div class="brandsub">Notulen / verslag overleg</div></div>
<h1>${esc(titel)}</h1>
<div class="meta">${esc(o.type || "")}${o.datum ? " &middot; " + esc(o.datum) : ""}</div>
<table class="info">${infoRow("Datum", o.datum)}${infoRow("Type", o.type)}${infoRow("Voorzitter", o.voorzitter)}${infoRow("Notulist", o.notulist)}${infoRow("Aanwezigen", o.aanwezigen)}${infoRow("Afwezig", o.afwezigen)}</table>
<h2>Besproken punten</h2><div class="txt">${o.agenda && o.agenda.trim() ? dnl(o.agenda) : "—"}</div>
<h2>Actiepunten</h2><table class="acties"><thead><tr><th>Actie</th><th>Wie</th><th>Wanneer</th></tr></thead><tbody>${actieRows}</tbody></table>
<h2>Besluiten</h2><div class="txt">${o.besluiten && o.besluiten.trim() ? dnl(o.besluiten) : "—"}</div>
${o.volgende ? `<h2>Volgende overleg</h2><div class="txt">${dnl(o.volgende)}</div>` : ""}
<div class="sig"><div class="sigline"></div><div><b>${esc(o.notulist || "")}</b></div><div class="brandsub">Notulist</div></div>
<div class="foot">Vertrouwelijk — uitsluitend voor intern gebruik.</div>
</body></html>`;
}

export function downloadOverlegWord(filename, o) {
  downloadWord(filename, buildOverlegHTML(o));
}

export function downloadOverlegPDF(filename, o) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const marginX = 14;
  const titel = o.titel || o.type || "Overleg";

  doc.setFillColor(28, 100, 176); doc.rect(0, 0, pageW, 4, "F");
  doc.setFont("helvetica", "bold"); doc.setFontSize(13); doc.setTextColor(15, 23, 42);
  doc.text("Clazing Convenience Food B.V.", marginX, 16);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(100, 116, 139);
  doc.text("Notulen / verslag overleg", marginX, 21);
  doc.setDrawColor(28, 100, 176); doc.setLineWidth(0.6); doc.line(marginX, 25, pageW - marginX, 25);

  let y = 33;
  doc.setFont("helvetica", "bold"); doc.setFontSize(16); doc.setTextColor(28, 100, 176);
  doc.text(doc.splitTextToSize(titel, pageW - 2 * marginX), marginX, y); y += 6;
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(100, 116, 139);
  doc.text(`${o.type || ""}${o.datum ? " · " + o.datum : ""}`, marginX, y); y += 6;

  const info = [];
  if (o.datum) info.push(["Datum", o.datum]);
  if (o.type) info.push(["Type", o.type]);
  if (o.voorzitter) info.push(["Voorzitter", o.voorzitter]);
  if (o.notulist) info.push(["Notulist", o.notulist]);
  if (o.aanwezigen) info.push(["Aanwezigen", o.aanwezigen]);
  if (o.afwezigen) info.push(["Afwezig", o.afwezigen]);
  if (info.length) {
    autoTable(doc, {
      startY: y, margin: { left: marginX, right: marginX }, theme: "plain",
      body: info,
      columnStyles: { 0: { fontStyle: "bold", textColor: [71, 85, 105], cellWidth: 38 }, 1: { textColor: [15, 23, 42] } },
      styles: { fontSize: 9, cellPadding: 1.4, overflow: "linebreak" },
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  const heading = (txt) => {
    if (y > 262) { doc.addPage(); y = 20; }
    doc.setFont("helvetica", "bold"); doc.setFontSize(11); doc.setTextColor(28, 100, 176);
    doc.text(txt, marginX, y); y += 1.5;
    doc.setDrawColor(28, 100, 176); doc.setLineWidth(0.4); doc.line(marginX, y, pageW - marginX, y); y += 5;
  };
  const para = (txt) => {
    doc.setFont("helvetica", "normal"); doc.setFontSize(9.5); doc.setTextColor(30, 41, 59);
    const lines = doc.splitTextToSize(txt && String(txt).trim() ? String(txt) : "—", pageW - 2 * marginX);
    lines.forEach((ln) => { if (y > 285) { doc.addPage(); y = 20; } doc.text(ln, marginX, y); y += 4.8; });
    y += 3;
  };

  heading("Besproken punten");
  para(o.agenda);

  heading("Actiepunten");
  const acties = Array.isArray(o.acties) ? o.acties.filter((a) => a && (a.wat || a.wie || a.wanneer)) : [];
  if (acties.length) {
    autoTable(doc, {
      startY: y, margin: { left: marginX, right: marginX },
      head: [["Actie", "Wie", "Wanneer"]],
      body: acties.map((a) => [a.wat || "", a.wie || "", a.wanneer || ""]),
      headStyles: { fillColor: [241, 245, 249], textColor: [71, 85, 105], fontSize: 8.5, fontStyle: "bold" },
      bodyStyles: { fontSize: 9, cellPadding: 1.8, textColor: [15, 23, 42] },
      styles: { lineColor: [226, 232, 240], lineWidth: 0.1, overflow: "linebreak" },
      columnStyles: { 0: { cellWidth: "auto" }, 1: { cellWidth: 45 }, 2: { cellWidth: 32 } },
    });
    y = doc.lastAutoTable.finalY + 6;
  } else { para("—"); }

  heading("Besluiten");
  para(o.besluiten);

  if (o.volgende) { heading("Volgende overleg"); para(o.volgende); }

  if (y > 250) { doc.addPage(); y = 20; }
  y += 8;
  doc.setDrawColor(148, 163, 184); doc.setLineWidth(0.3); doc.line(marginX, y, marginX + 70, y); y += 5;
  doc.setFont("helvetica", "bold"); doc.setFontSize(10); doc.setTextColor(15, 23, 42);
  doc.text(o.notulist || "", marginX, y); y += 4.5;
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(100, 116, 139);
  doc.text("Notulist", marginX, y);

  const total = doc.getNumberOfPages();
  for (let i = 1; i <= total; i++) {
    doc.setPage(i);
    const ph = doc.internal.pageSize.getHeight();
    doc.setFontSize(7.5); doc.setTextColor(148, 163, 184);
    doc.text(`Vertrouwelijk — intern · ${titel} · pagina ${i}/${total}`, pageW / 2, ph - 6, { align: "center" });
  }
  doc.save(filename);
}
